import { Component, OnInit, Renderer2 } from '@angular/core';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import * as validationMsg from "src/app/_core/_helpers/validationMsg.json";
import { FacebookLoginProvider, GoogleLoginProvider, SocialUser } from 'angularx-social-login';
import { AuthService as SocialAuthService } from 'angularx-social-login';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { CommonService } from '../../../_services/common.service';
import _Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
declare let gtag: Function;
declare let AppleID: any;
@Component({
  selector: 'tangram-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  numberOfCurators: number;
  signUpwithEmail = false;
  validMessage = validationMsg.login;
  // get image path
  imgPath = appConfig;
  appleOptions: any;
  isUniversitySsoLoading: boolean = false;
  processingEdlink: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public authService: AuthService,
    private socialAuthService: SocialAuthService,
    private commonService: CommonService,
    private alertModalService: AlertModalService,
  ) { }

  ngOnInit() {
    this.renderer.removeClass(document.body, 'home-page');
    this.getCuratorsCount()
    this.initializeForm();
    this.handleEdlinkSsoReturn();
  }

  /**
   * Completes a "Login with Edlink" round-trip. The backend redirects here
   * with the login payload in the URL *fragment* (#edlink=success&payload=…),
   * which we decode, store like any other login, clear from the address bar,
   * then route exactly as email/social login does.
   */
  private handleEdlinkSsoReturn() {
    // The backend redirects here as `/#/login?edlink=…&payload=…`. Because the
    // app uses hash-based routing, those land as this route's query params
    // (and stay inside the URL fragment — not sent to the server). Read them via
    // ActivatedRoute rather than window.location.hash, which holds the route.
    this.route.queryParams.pipe(first()).subscribe((params) => {
      const status = params['edlink'];
      if (!status) return;

      if (status === 'error') {
        const reason = params['reason'] || 'Edlink sign-in failed. Please try again.';
        this.alertModalService.info(reason).subscribe();
        // Drop the SSO params from the address bar.
        this.router.navigate([], { queryParams: {}, replaceUrl: true });
        return;
      }

      const encoded = params['payload'];
      if (status !== 'success' || !encoded) return;

      try {
        const data = JSON.parse(atob(encoded));
        this.authService.saveLoggedInUser({ data });
        gtag('event', 'login_success', { 'method_name': 'Edlink' });
        const ltiCtx = data.ltiContext;
        if (data.isLtiLaunch) {
          if (ltiCtx && ltiCtx.intent === 'class' && ltiCtx.class && ltiCtx.class.id) {
            localStorage.setItem('edlinkLtiContext', JSON.stringify(ltiCtx));
          } else {
            // LTI launch from outside a course — clear any stale course context.
            localStorage.removeItem('edlinkLtiContext');
          }
        }
        this.hasLoggedInBefore(data.loggedInBefore);
      } catch (e) {
        this.alertModalService.info('Edlink sign-in could not be completed. Please try again.').subscribe();
        this.router.navigate([], { queryParams: {}, replaceUrl: true });
      }
    });
  }

  initializeForm() {

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      // Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'),
      // Validators.minLength(6)]]
    });
  }

  getCuratorsCount() {
    this.authService.curatorsCount().subscribe((res: any) => {
      this.numberOfCurators = res.count;
    })
  }

  signInwithApple() {
    //analytic tag
    gtag('event', 'loggedIn_by', {
      'event_category': 'sign_in',
      'event_label': 'facebook'
    });

    /**
    * This function will initialize the `AppleID.auth` object with parameter we pass in.
    */
    // const initApple = () => {
    AppleID.auth.init({
      clientId: `${environment.appleClientId}`, // This is the service ID we created.
      scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
      redirectURI: `${environment.appRedirectUrl}`, // As registered along with our service ID
      state: "origin:web", // Any string of your choice that you may use for some logic. It's optional and you may omit it.
      usePopup: true, // Important if we want to capture the data apple sends on the client side.        
    });
    // };

    this.singInApple().then((data: any) => {
      console.log(data);
      if (data.authorization) {
        /** apple data to be send in backend */
        const appleData: any = {
          "authorization": data.authorization.id_token,
          "firstName": "",
          "lastName": "",
          "email": ""
        };

        if (data.user) {
          appleData.email = data.user.email ? data.user.email : '';
          appleData.firstName = data.user.name.firstName ? data.user.name.firstName : '';
          appleData.lastName = data.user.name.lastName ? data.user.name.lastName : '';
        }

        // Register apple user
        this.authService.registerAppleUser(appleData).subscribe((res: any) => {
          // Check if its new account then redirect to registration page for entering screen name
          if (res.data.isNewAccount) {
            // Screen name is required for the registration, so when user do social login
            // and user has not added screen name then redirect to registration page for entering screen name
            this.commonService.raiseEventToHideRegistrationControlsExceptScreenName(res.data);
            this.router.navigate(['/register']);
          } else {
            gtag('event', 'login_success', {
              'method_name': 'Apple',
              'login_email': appleData.email,
            });
            // this.router.navigate(['/home']);
            this.hasLoggedInBefore(res.data.loggedInBefore);
          }
        });
      } else {
        this.alertModalService.info('Please try again, token expired').subscribe();
      }

    }).catch((error) => {
      console.log(error);
    });


  }

  signInwithEmail() {
    this.signUpwithEmail = !this.signUpwithEmail;
  }

  signUpWithCanvas() {
    // Canvas sign-up requires the OAuth start endpoint to be configured in
    // the environment (`canvasSignUpUrl`). The fallback path
    // `/canvas/oauth/start` is NOT mounted on the backend yet — hitting it
    // returns null / 404 — so guard the click and surface a friendly
    // message until the SSO flow is wired up.
    const targetUrl = environment.canvasSignUpUrl;
    if (!targetUrl) {
      this.alertModalService.info('Canvas sign-up is not available yet. Please use email or Google to sign up, or contact your administrator.').subscribe();
      return;
    }
    window.location.href = targetUrl;
  }

  loginWithUniversity() {
    this.isUniversitySsoLoading = true;
    // Edlink "Login with your school account" — a full-page OAuth2 redirect.
    // The backend (`/edlink/sso/login`) bounces the user to Edlink and the
    // callback returns them here with a login payload (see handleEdlinkSsoReturn).
    const targetUrl = environment.universitySsoUrl || `${environment.baseUrl}/edlink/sso/login`;
    if (!targetUrl) {
      this.isUniversitySsoLoading = false;
      this.alertModalService.info('University SSO is not configured yet. Please contact your administrator.').subscribe();
      return;
    }
    window.location.href = targetUrl;
  }

  async singInApple() {
    const response = await AppleID.auth.signIn();
    return response;
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Sign in with facebook
   */
  signInWithFB(): void {
    //analytic tag
    gtag('event', 'loggedIn_by', {
      'event_category': 'sign_in',
      'event_label': 'facebook'
    });
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then((data) => {
      gtag('event', 'login_success', {
        'method_name': 'facebook',
        'login_email': data.email,
      });
      this.onSocialSignUP(data);
    });
  }

  /**
   * Called when social signup
   * @param data data to be registerd or logged in
   */
  onSocialSignUP(data: SocialUser) {
    const register = {
      "accountType": data.provider,
      "firstName": data.firstName,
      "lastName": data.lastName,
      "email": data.email,
      "socialId": data.id
    };

    // Register social user
    this.authService.registerSocialUser(register).subscribe((data) => {
      // Check if its new account then redirect to registration page for entering screen name
      if (data.data.isNewAccount) {
        // Screen name is required for the registration, so when user do social login
        // and user has not added screen name then redirect to registration page for entering screen name
        this.commonService.raiseEventToHideRegistrationControlsExceptScreenName(data.data);
        this.router.navigate(['/register']);
      } else {
        this.commonService.callDashboardEvent(true);
        if(this.route.snapshot.queryParamMap.get('returnUrl')){
          this.router.navigate([this.route.snapshot.queryParamMap.get('returnUrl')]);
        }else{
          // this.router.navigate(['/home']);
          this.hasLoggedInBefore(data.data.loggedInBefore);
        }
      }
    });
  }

  /**
   * Sign in with google
   */
  signInWithGoogle() {
    //analytic tag
    gtag('event', 'loggedIn_by', {
      'event_category': 'sign_in',
      'event_label': 'google'
    });
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then((data) => {
      gtag('event', 'login_success', {
        'method_name': 'Google',
        'login_email': data.email,
      });
      this.onSocialSignUP(data);
    });
  }
  //submit login form
  onSubmit() {
    //analytic tag
    gtag('event', 'loggedIn_by', {
      'event_category': 'sign_in',
      'event_label': 'normal'
    });
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    //call login api by passing email and password
    this.authService.login(this.f.email.value, this.f.password.value)
      .pipe(first())
      .subscribe((res: any) => {
        // Otherwise redirect to topic selection screen       
        if (!res.success && res.message) {
          this.alertModalService.info(res.message).subscribe();
        } else {
          if(this.route.snapshot.queryParamMap.get('returnUrl')){
            this.router.navigate([this.route.snapshot.queryParamMap.get('returnUrl')]);
          }else{
            gtag('event', 'login_success', {
              'method_name': 'local',
              'login_email': this.loginForm.value.email,
            });
            // this.router.navigate(['/home']);
            this.hasLoggedInBefore(res.data.loggedInBefore);
          }

        }
        this.onReset();
      });
  }

  hasLoggedInBefore (flag) {
    if (flag) {
      this.router.navigate(['/home']);
    } else {
      this.alertModalService.info('For the best experience, please complete your profile.').subscribe();
      this.router.navigate(['/account-management/edit-profile']);
    }
  }

  // reset login form
  onReset() {
    this.submitted = false;
    this.loginForm.reset();
  }

  //open forget password modal
  openForgetPwdModal() {
    const _modalRef = this.modalService.open(ForgotPasswordComponent, { centered: true, windowClass: 'modal-small' });
  }

  // back to home page
  backToHome() {
    if (this.signUpwithEmail) {
      this.signUpwithEmail = !this.signUpwithEmail;
    } else {
      this.router.navigate(['/home']);
    }
  }
}

